/**
 * Location slugs used by the Events collection `location` select field.
 * TEMPORARY: convert to a `relationship` to a `locations` collection once one exists.
 */
export const eventLocationSlugs = [
  'berlin-mitte-wedding',
  'berlin-frankfurter-tor',
  'berlin-neukoelln',
  'berlin-adlershof',
  'frankfurt-riedberg',
  'tuebingen',
  'cologne-k115',
] as const

export type EventLocationSlug = (typeof eventLocationSlugs)[number]

export function isEventLocationSlug(value: string): value is EventLocationSlug {
  return (eventLocationSlugs as readonly string[]).includes(value)
}

export const eventLocationOptions = eventLocationSlugs.map((value) => ({
  label: value,
  value,
}))

/** Location options for promotions, including an "all locations" choice. */
export const promotionLocationOptions = [
  { label: 'All', value: 'all' },
  ...eventLocationOptions,
]
